"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const session_1 = require("./session");
const sigs_1 = require("./Notification/sigs");
const WebSocket = require('isomorphic-ws');
class SmartComposeSession {
    constructor(envelope, url, sessionInfo, userAuthToken, urlParams, callbackUpdateUIElements, callbackLogging, sessionId) {
        this.backspaceNum = 0;
        this.callbackfunction = callbackUpdateUIElements;
        this.callbackLogging = callbackLogging;
        this.curReceived = true;
        this.date = envelope.dateTime;
        this.e2ePreLatency = 0;
        this.lastUpdatedEmailBody = "";
        this.envelope = envelope;
        this.frameNumber = 0;
        this.offset = 0;
        this.requireSessionUpdate = false;
        this.requestNumber = 0;
        this.requestsMap = new Map();
        this.sessionId = sessionId;
        this.sessionInfo = sessionInfo;
        this.smartComposeInteractionList = [];
        this.state = session_1.States.UnStarted;
        this.reconnectAttempts = 0;
        this.urlParams = urlParams;
        this.userAuthToken = userAuthToken;
        if (!url) {
            url = SmartComposeSession.DEFAULT_URL;
        }
        this.url = url;
        this.ws = this.createWS(this.url);
        this.setupWSHandler(this.ws, this.envelope, this.userAuthToken, session_1.States.Started);
    }
    createWS(url) {
        if (!url) {
            url = SmartComposeSession.DEFAULT_URL;
        }
        return new WebSocket(url + '?' + SmartComposeSession.PROTOCOL_VERSION, SmartComposeSession.PROTOCOL_NAME);
    }
    setupWSHandler(websocket, envelope, userAuthToken, curState) {
        let initTest = {
            a: 'Bearer ' + userAuthToken,
            s: envelope.subject,
            u: envelope.user,
            t: envelope.to,
            n: Array.from(envelope.constraints.keys()),
            v: Array.from(envelope.constraints.values())
        };
        websocket.onopen = () => {
            // Web Socket is connected, send data using send()
            websocket.send(JSON.stringify(initTest));
            this.state = curState;
            if (this.state == session_1.States.WSBOpen) {
                this.wsBackup = websocket;
                // after wsBackup open replace main websocket
                this.ws = this.wsBackup;
                this.wsBackup = undefined;
            }
            else {
                this.ws = websocket;
            }
        };
        websocket.onclose = (event) => {
            if (this.callbackLogging) {
                this.callbackLogging("Websocket close event code" + event.code);
            }
            if (event.code == 1002 || event.code == 1008) {
                this.state = session_1.States.Faulted;
            }
            else if (event.code == 1000) {
                this.state = session_1.States.Complete;
            }
            else {
                // Stop auto reconnection when session complete or inactive
                if (this.state == session_1.States.Complete || this.state == session_1.States.Inactive) {
                    return;
                }
                // Need auto reconnection, separate UnStarted and Restarting
                if (this.state != session_1.States.UnStarted) {
                    this.state = session_1.States.Restarting;
                }
                if (this.reconnectAttempts >= SmartComposeSession.MAX_RECONNECT_ATTEMPTS) {
                    return;
                }
                this.reconnectAttempts++;
                let timeout = SmartComposeSession.RECONNECT_INTERVAL * this.reconnectAttempts + Math.random() * 500;
                console.log("timeout" + timeout);
                setTimeout(() => {
                    if (this.state == session_1.States.UnStarted) {
                        this.reconnectWS(this.envelope, this.url, this.userAuthToken, session_1.States.Started);
                    }
                    else {
                        this.reconnectWS(this.envelope, this.url, this.userAuthToken, session_1.States.Restarted);
                    }
                }, timeout); // 250 500 1000 2000....60000
            }
        };
        websocket.onerror = (error) => {
            if (this.state != session_1.States.UnStarted) {
                this.state = session_1.States.Faulted;
            }
        };
        websocket.onmessage = (evt) => {
            let response = undefined;
            if (this.state == session_1.States.Open || this.state == session_1.States.Started || this.state == session_1.States.BuildingWSB) {
                response = this.processResponse(evt);
                // send latest outstanding request while ws still connected
                if (this.toSendRequest && (this.state == session_1.States.Open || this.state == session_1.States.BuildingWSB)) {
                    this.sendRequest(this.toSendRequest[0], true, this.toSendRequest[1]);
                    this.toSendRequest = undefined;
                }
            }
            else if (this.state == session_1.States.Restarted || this.state == session_1.States.WSBOpen) {
                response = this.processResponse(evt);
            }
            if (response) {
                this.callbackfunction(response);
            }
        };
    }
    reconnectWS(envelope, url, userAuthToken, curState) {
        let ws = this.createWS(url);
        this.setupWSHandler(ws, envelope, userAuthToken, curState);
    }
    buildBackupWS() {
        this.state = session_1.States.BuildingWSB;
        this.reconnectWS(this.envelope, this.url, this.userAuthToken, session_1.States.WSBOpen);
    }
    requestSuggestion(body, salutationAppropriate, suggestionAccepted, context, cvId) {
        this.requestNumber += 1;
        let suggestionRequest = new session_1.SuggestionRequest(salutationAppropriate, this.e2ePreLatency, suggestionAccepted, this.requestNumber, cvId);
        if (this.state == session_1.States.Open || this.state == session_1.States.Started || this.state == session_1.States.BuildingWSB) {
            // While session state is ready to send request
            // classify suggestion request type
            if (body.length >= this.lastUpdatedEmailBody.length && body.startsWith(this.lastUpdatedEmailBody)) {
                // filter current emailbody not changed
                if (body.length == this.lastUpdatedEmailBody.length) {
                    return;
                }
                // send append Delta if user only type new words
                let append = body.substring(this.lastUpdatedEmailBody.length);
                this.backspaceNum += append.length;
                suggestionRequest.a = append.substr(-2048);
            }
            else if (body.length < this.lastUpdatedEmailBody.length && this.lastUpdatedEmailBody.startsWith(body)) {
                // send the number of characters removed
                let removed = this.lastUpdatedEmailBody.length - body.length;
                this.backspaceNum -= removed;
                if (this.backspaceNum <= 0) {
                    suggestionRequest.b = body.substr(-SmartComposeSession.PREFIX_MAX);
                    this.backspaceNum = Math.min(body.length, SmartComposeSession.BACKSPACE_MAX);
                }
                else {
                    suggestionRequest.r = removed;
                }
            }
            else {
                // send the latest 2048 chars in whole email body
                suggestionRequest.b = body.substr(-SmartComposeSession.PREFIX_MAX);
                this.backspaceNum = Math.min(body.length, SmartComposeSession.BACKSPACE_MAX);
            }
            // check updated session
            if (this.requireSessionUpdate) {
                // Add updated fields in request object (both subject and to for now)
                suggestionRequest.s = this.envelope.subject;
                suggestionRequest.t = this.envelope.to;
                // clear Session update flag
                this.requireSessionUpdate = false;
            }
            if (!this.curReceived) {
                this.toSendRequest = [suggestionRequest, context];
            }
            else {
                this.sendRequest(suggestionRequest, false, context);
            }
        }
        else if (this.state == session_1.States.Restarted || this.state == session_1.States.WSBOpen) {
            // while Session websocket is reconnected or backup ws just opened
            // send whole email prefix
            suggestionRequest.b = body.substr(-2048);
            this.sendRequest(suggestionRequest, false, context);
        }
    }
    requestSuggestionForChar(textAdded, salutationAppropriate, suggestionAccepted, context, cvId) {
        this.requestNumber += 1;
        let requestForChar = new session_1.SuggestionRequest(salutationAppropriate, this.e2ePreLatency, suggestionAccepted, this.requestNumber, cvId);
        requestForChar.a = textAdded;
        // check updated session
        if (this.requireSessionUpdate) {
            // Add updated fields in request object (both subject and to for now)
            requestForChar.s = this.envelope.subject;
            requestForChar.t = this.envelope.to;
            // clear Session update flag
            this.requireSessionUpdate = false;
        }
        if (this.state == session_1.States.Open || this.state == session_1.States.Started || this.state == session_1.States.BuildingWSB) {
            if (!this.curReceived) {
                this.toSendRequest = [requestForChar, context];
            }
            else {
                this.sendRequest(requestForChar, false, context);
            }
        }
        else if (this.state == session_1.States.Restarted || this.state == session_1.States.WSBOpen) {
            // while Session websocket is reconnected or backup ws just opened
            // send whole email prefix, keep original sessionId
            this.sendRequest(requestForChar, false, context);
        }
    }
    sendRequest(suggestionRequest, isOutstanding, context) {
        let requestNumber = suggestionRequest.i;
        let suggestionRequestStr = JSON.stringify(suggestionRequest);
        if (suggestionRequestStr.length <= SmartComposeSession.MAX_MESSAGE_SIZE) {
            this.requestsMap.set(requestNumber, new session_1.RequestsInfo(new Date().getTime(), context));
            this.ws.send(suggestionRequestStr);
            if (suggestionRequest.b) {
                this.lastUpdatedEmailBody = suggestionRequest.b;
            }
            else if (suggestionRequest.a) {
                this.lastUpdatedEmailBody += suggestionRequest.a;
            }
            else if (suggestionRequest.r) {
                let len = this.lastUpdatedEmailBody.length;
                this.lastUpdatedEmailBody = this.lastUpdatedEmailBody.substr(0, len - suggestionRequest.r);
            }
            this.e2ePreLatency = 0;
            if (!isOutstanding) {
                this.curReceived = false;
            }
        }
    }
    processResponse(evt) {
        let responseTime = new Date().getTime();
        let received_msg = JSON.parse(evt.data);
        // traceId built in client as sessionId.requestNumber
        // sessionId in traceId is same to server sessionId
        if (received_msg && received_msg.f && received_msg.i) {
            // correlate the request and response
            let requestInfo = this.requestsMap.get(received_msg.f);
            if (requestInfo) {
                this.e2ePreLatency = responseTime - requestInfo.time;
                received_msg.context = requestInfo.context;
                this.requestsMap.delete(received_msg.f);
            }
            received_msg.t = received_msg.i + '.' + received_msg.f;
        }
        // keep the same sessionId when ws reconnect
        if (this.state == session_1.States.Started || this.sessionId == undefined) {
            this.sessionId = received_msg.i;
        }
        else {
            received_msg.i = this.sessionId;
        }
        this.curReceived = true;
        if (this.state != session_1.States.BuildingWSB) {
            this.state = session_1.States.Open;
        }
        // if server blocked this session
        if (received_msg.x == -1) {
            this.ws.close(1000, "BlockedMSG Disconnection");
        }
        // if server send reconnect signal, build backup ws
        if (received_msg.r == 1 && this.reconnectAttempts < SmartComposeSession.MAX_RECONNECT_ATTEMPTS) {
            this.reconnectAttempts++;
            this.buildBackupWS();
        }
        return received_msg;
    }
    deactivateSession() {
        this.state = session_1.States.Inactive;
    }
    activateSession() {
        this.reconnectWS(this.envelope, this.url, this.userAuthToken, session_1.States.Restarted);
    }
    updateSession(subject, to) {
        this.envelope.subject = subject;
        if (to.length > session_1.Envelope.MAX_RECIPIENT_NUM) {
            to = to.slice(0, 3);
        }
        this.envelope.to = to;
        this.requireSessionUpdate = true;
    }
    updateAuthToken(auth) {
        this.userAuthToken = auth;
    }
    addSuggestionInfo(smartComposeInteraction) {
        this.smartComposeInteractionList.push(smartComposeInteraction);
    }
    getSignalInformation() {
        let signalInfo = new sigs_1.SigsSmartComposeSignalInfo();
        return signalInfo.getSignalInformation(this);
    }
    terminateSession() {
        if (this.ws.readyState === WebSocket.OPEN) {
            this.ws.close(1000, "Deliberate disconnection");
        }
        this.state = session_1.States.Complete;
    }
}
SmartComposeSession.BACKSPACE_MAX = 20;
SmartComposeSession.DEFAULT_URL = "wss://fe-26.qas.bing.net/compose";
SmartComposeSession.MAX_MESSAGE_SIZE = 4096;
SmartComposeSession.MAX_RECONNECT_ATTEMPTS = 3;
SmartComposeSession.PREFIX_MAX = 2048;
SmartComposeSession.PROTOCOL_VERSION = "v=1";
SmartComposeSession.PROTOCOL_NAME = "sc1";
SmartComposeSession.RECONNECT_INTERVAL = 2000;
function createSmartComposeSession(envelope, url, sessionInfo, userAuthToken, urlParams, callbackUpdateUIElements, callbackLogging) {
    return new SmartComposeSession(envelope, url, sessionInfo, userAuthToken, urlParams, callbackUpdateUIElements, callbackLogging);
}
exports.createSmartComposeSession = createSmartComposeSession;
